<template>
  <v-card flat dense>
    <v-form ref="form" v-model="valid">
      <v-card-title>
        <span class="mr-4">
          {{ $t('ITEM.CREATE') }} {{ $t('BOOKING.RESERVATIONS.ITEM') }}
        </span>
        <v-spacer></v-spacer>
        <span class="text-body-2">{{ $t('ITEM.STATUS') }}</span>
        <div>
          <booking-reservations-status
            v-model="reservation.status_id"
            name="status_id"
            style="width: 140px"
            :error-messages="errors.status_id"
            disabled
            @change="clearErrorByName('status_id')"
          />
        </div>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle v-if="errorsWithoutForm.length">
        <errors :errors="errorsWithoutForm" />
      </v-card-subtitle>
      <v-card-text>
        <booking-reservation-form
          v-model="reservation"
          :resource="resource"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        ></booking-reservation-form>
        <v-card-actions>
          <v-btn outlined depressed color="grey" @click="cancel">
            {{ $t('BUTTON.CANCEL') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" :disabled="!valid" @click="create">
            {{ $t('BUTTON.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import Errors from '@/modules/_global/_components/Errors';
import BookingReservationForm from '../forms/BookingReservationForm';
import BookingReservationsStatus from '../forms/BookingReservationsStatus.vue';
import { mapActions } from 'vuex';

export default {
  name: 'CreateReservation',

  components: {
    Errors,
    BookingReservationForm,
    BookingReservationsStatus
  },

  mixins: [errors],

  props: {
    resource: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      reservation: {}
    };
  },

  computed: {
    errorsWithoutForm() {
      return ['resource_id', '_unexpected']
        .reduce((acc, i) => acc.concat(this.errors.get(i)), [])
        .filter(i => i);
    }
  },

  mounted() {
    this.reservation.number_of_visitors = this.resource.capacity;
  },

  methods: {
    ...mapActions('booking_resources', ['getBookingResource']),
    ...mapActions('booking_reservations', ['storeBookingReservation']),

    cancel() {
      this.$emit('cancel');
    },

    create() {
      const reservation = {
        ...this.reservation,
        resource_id: this.resource.id
      };

      this.storeBookingReservation({ reservation })
        .then(response => {
          this.$emit('created', response.data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
